import React, { Component } from "react"
import { connect } from "react-redux"
import { Form, Input, Button, Row, Col, DatePicker, Icon, Select, Modal } from "antd"
import { AuthActions, MainActions } from "redux-store/models"
import { withRouter } from "react-router"
import moment from "moment"
import { docType } from "../../config"

const { Option } = Select

class EditUser extends Component {
  state = {
    skinSelected: "",
    agentSelected: "",
    loading: false,
  }

  resetState = async (id) => {
    const role = this.props.userDetail.role
    if (role === "user") {
      await this.props.getUserByUserId(id)
    } else if (role === "agency") {
      await this.props.getUserDetail(id)
    } else if (role === "agent") {
      await this.props.getAgentByUserId(id)
    }
  }

  fetchUserByRoleAndId = async (role, id) => {
    if (!id) return

    if (role === "user") {
      await this.props.getUserByUserId(id)
    } else if (role === "agency") {
      await this.props.getUserDetail(id)
    } else if (role === "agent") {
      await this.props.getAgentByUserId(id)
    }
  }

  componentDidMount() {
    const { userDetail, match, location } = this.props
    const params = new URLSearchParams(location.search)
    const role = params.get("role")
    const userId = match?.params?.id

    if (!userDetail || Object.keys(userDetail).length === 0) {
      this.fetchUserByRoleAndId(role, userId)
    }
  }

  handleFormSubmit = (e) => {
    e.preventDefault()
    const { form, userDetail, activeSkinId, updateUserDetail } = this.props

    const isRomangaSkin = activeSkinId === 74
    form.validateFields((err, values) => {
      if (!err) {
        let payload = { ...values }

        // Only for agency role, map fields to a_*
        if (userDetail.role === "agency") {
          const account = values.account || {}

          payload.a_ragione_sociale =
            account.ragione_sociale ?? values.ragione_sociale ?? null
          payload.a_insegna = account.insegna ?? values.insegna ?? null
          payload.a_iva = account.p_iva ?? values.p_iva ?? null
          payload.a_address = account.address ?? values.address ?? null
          payload.a_cordinate = account.cordinate ?? values.cordinate ?? null
          payload.a_phone = account.phone ?? values.phone ?? null
          payload.a_rent =
            (account.rent ?? values.rent)
              ? Number(String(account.rent ?? values.rent).replace(",", "."))
              : null
          payload.a_cap = account.cap ?? values.cap ?? null
          payload.a_city = account.city ?? values.city ?? null
          payload.a_comune_code = account.comune_code ?? values.comune_code ?? null
          payload.a_country = account.country ?? values.country ?? null

          delete payload.city
          delete payload.comune_code
          delete payload.country
        }

        console.log("Payload to send:", payload)

        updateUserDetail(
          userDetail.id,
          payload.phone,
          isRomangaSkin ? "1" : payload.document_type,
          isRomangaSkin ? "1" : payload.document_number,
          isRomangaSkin ? "1" : payload.rilasciato_da,
          isRomangaSkin ? "1" : payload.luogo_di_rilascio,
          isRomangaSkin
            ? new Date().toISOString().split("T")[0]
            : payload.data_di_rilascio,
          isRomangaSkin
            ? new Date().toISOString().split("T")[0]
            : payload.data_di_scadenza,
          payload.a_insegna ?? payload.insegna,
          payload.a_cordinate ?? payload.cordinate,
          payload.a_phone ?? payload.phone,
          payload.a_address ?? payload.address,
          payload.a_city ?? payload.city,
          payload.provincia ?? payload.a_comune_code ?? payload.comune_code,
          payload.a_cap ?? payload.cap,
          payload.a_country ?? payload.country,
          payload.a_rent ?? payload.rent,
          payload.password,
          payload.confirm_password,
          (payload.a_percentage =
            payload.a_percentage !== undefined && payload.a_percentage !== null
              ? Number(String(payload.a_percentage).replace(",", "."))
              : null),
          activeSkinId,
          this.resetState,
          {
            username: payload.username,
            email: payload.email,
            a_ragione_sociale: payload.a_ragione_sociale,
            a_iva: payload.a_iva,
            first_name: payload.first_name,
            last_name: payload.last_name,
            birth_comune_code: payload.birth_comune_code,
            birth_country: payload.birth_country ?? payload.country,
            birth_place: payload.birth_place,
            birthday: payload.birthday,
            city: payload.a_city ?? payload.city,
            gender: payload.gender,
            personal_number: payload.personal_number,
            ragione_sociale: payload.a_ragione_sociale ?? payload.ragione_sociale,
            p_iva: payload.a_iva ?? payload.p_iva,
            country: payload.a_country ?? payload.country,
            address: payload.a_address ?? payload.address,
            cap: payload.a_cap ?? payload.cap,
            comune_code: payload.a_comune_code ?? payload.comune_code,
          },
          (loadingState) => this.setState({ loading: loadingState }),
        )
      }
    })
  }

  render() {
    const { loading } = this.state
    const {
      form,
      userDetail,
      history,
      activeSkinId,
      agents,
      skinList,
      setUserDetail,
      accountInfo,
    } = this.props
    const { getFieldDecorator } = form
    const role = accountInfo?.profile?.role?.name

    console.log(role)

    const agencyFields = {
      col1: [
        { key: "account.ragione_sociale", label: "Ragione Sociale" },
        { key: "account.insegna", label: "Insegna" },
        { key: "account.p_iva", label: "P.Iva" },
        { key: "account.address", label: "Sede Operativa" },
        { key: "account.cordinate", label: "Coordinate" },
        { key: "account.phone", label: "Telefono Agenzia" },
        { key: "email", label: "Email" },
        { key: "country", label: "Nazione di residenza" },
      ],
      col2: [
        { key: "city", label: "Comune" },
        { key: "account.comune_code", label: "Provincia di residenza" },
        { key: "account.rent", label: "Pagamento Mensile" },
        { key: "account.cap", label: "Cap" },
        { key: "phone", label: "Cellulare" },
        { key: "document_type", label: "Tipo Documento", type: "document" },
        { key: "document_number", label: "Numero Documento" },
        { key: "personal_number", label: "Codice Fiscale" },
      ],
      col3: [
        { key: "username", label: "Username" },
        { key: "password", label: "Password" },
        { key: "confirm_password", label: "Conferma Password" },
        { key: "rilasciato_da", label: "Rilasciato da", type: "rilasciato" },
        { key: "luogo_di_rilascio", label: "Luogo di rilascio" },
        { key: "data_di_rilascio", label: "Data di rilascio", type: "date" },
        { key: "data_di_scadenza", label: "Data di scadenza", type: "date" },
      ],
    }

    const agentFields = {
      col1: [
        { key: "ragione_sociale", label: "Ragione Sociale" },
        { key: "a_address", label: "Address" },
        { key: "first_name", label: "First Name" },
        { key: "last_name", label: "Last Name" },
        { key: "p_iva", label: "P.Iva" },
        { key: "birthday", label: "Compleanno", type: "date" },
        { key: "birth_place", label: "Comune di nascita" },
        { key: "birth_country", label: "Nazione" },
        { key: "birth_comune_code", label: "Sigla di provinca" },
      ],
      col2: [
        { key: "gender", label: "Gender", type: "gender" },
        { key: "cap", label: "Cap" },
        { key: "a_city", label: "Citta" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Cellulare" },
        { key: "country", label: "Nazione di residenza" },
        { key: "a_percentage", label: "Percentage" },
        { key: "document_type", label: "Tipo Documento", type: "document" },
        { key: "document_number", label: "Numero Documento" },
      ],
      col3: [
        { key: "username", label: "Username" },
        { key: "password", label: "Password" },
        { key: "confirm_password", label: "Conferma Password" },
        { key: "personal_number", label: "Codice Fiscale" },

        { key: "rilasciato_da", label: "Rilasciato da", type: "rilasciato" },
        { key: "luogo_di_rilascio", label: "Luogo di rilascio" },
        { key: "data_di_rilascio", label: "Data di rilascio", type: "date" },
        { key: "data_di_scadenza", label: "Data di scadenza", type: "date" },
      ],
    }

    const userFields = {
      col1: [
        { key: "first_name", label: "First Name" },
        { key: "last_name", label: "Last Name" },
        { key: "address", label: "Address" },
        { key: "birthday", label: "Compleanno", type: "date" },
        { key: "birth_country", label: "Nazione di residenza" },
        { key: "birth_comune_code", label: "Codice comune di nascita" },
        { key: "comune_code", label: "Codice comune di rezidenca" },
        { key: "birth_place", label: "Provincia di residenza" },
      ],
      col2: [
        { key: "gender", label: "Gender", type: "gender" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Cellulare" },
        { key: "city", label: "Citta" },
        { key: "cap", label: "Cap" },
        { key: "country", label: "Nazione" },
        { key: "document_type", label: "Tipo Documento", type: "document" },
        { key: "document_number", label: "Numero Documento" },
      ],
      col3: [
        { key: "username", label: "Username" },
        { key: "password", label: "Password" },
        { key: "confirm_password", label: "Conferma Password" },
        { key: "personal_number", label: "Codice Fiscale" },
        ...(activeSkinId === 74
          ? [{ key: "p_iva", label: "Partita IVA" }]
          : [
              { key: "rilasciato_da", label: "Rilasciato da", type: "rilasciato" },
              { key: "luogo_di_rilascio", label: "Luogo di rilascio" },
              { key: "data_di_rilascio", label: "Data di rilascio", type: "date" },
              { key: "data_di_scadenza", label: "Data di scadenza", type: "date" },
            ]),
      ],
    }

    const formMapping =
      userDetail?.role === "agent"
        ? agentFields
        : userDetail?.role === "user"
          ? userFields
          : agencyFields

    function getNestedValue(obj, path) {
      return path.split(".").reduce((acc, key) => acc?.[key], obj)
    }

    const renderFormItems = (fields) =>
      fields.map(({ key, label, type }) => {
        const value = getNestedValue(userDetail, key)

        return (
          <Form.Item label={label} key={key}>
            {getFieldDecorator(key, {
              initialValue:
                type === "date"
                  ? value
                    ? moment(value)
                    : null
                  : type === "document"
                    ? userDetail?.document_type?.toString()
                    : type === "gender"
                      ? userDetail?.gender
                      : type === "rilasciato"
                        ? userDetail?.rilasciato_da?.toString()
                        : value?.toString() || null,
              rules: [
                { required: false, message: `${label} is required` },
                ...(key === "password"
                  ? [
                      {
                        min: 8,
                        message: "La password deve contenere almeno 8 caratteri.",
                      },
                      {
                        pattern:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>_\-+=\\[\]~/`]).{8,}$/,
                        message:
                          "La password deve contenere almeno una lettera maiuscola, una lettera minuscola, un numero e un carattere speciale.",
                      },
                      {
                        validator: (rule, value, callback) => {
                          const username = form.getFieldValue("username")

                          if (
                            value &&
                            username &&
                            value.toLowerCase().includes(username.toLowerCase())
                          ) {
                            callback("La password non può contenere il nome utente.")
                          } else {
                            callback()
                          }
                        },
                      },
                    ]
                  : []),

                ...(key === "confirm_password"
                  ? [
                      {
                        validator: (rule, value, callback) => {
                          const password = form.getFieldValue("password")

                          if (!value || value === password) {
                            callback()
                          } else {
                            callback("Le password non coincidono.")
                          }
                        },
                      },
                    ]
                  : []),
              ],
            })(
              type === "date" ? (
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder={`Select ${label}`}
                  disabled={role === "agent"}
                />
              ) : type === "document" ? (
                <Select placeholder="Tipo documento" disabled={role === "agent"}>
                  {docType.map((doc) => (
                    <Option key={doc.id} value={doc.id}>
                      {doc.name}
                    </Option>
                  ))}
                </Select>
              ) : type === "gender" ? (
                <Select placeholder="Gender" disabled={role === "agent"}>
                  <Option value="F">Donna</Option>
                  <Option value="M">Uomo</Option>
                </Select>
              ) : type === "rilasciato" ? (
                <Select placeholder="Rilasciato da" disabled={role === "agent"}>
                  <Option value="1">Comune</Option>
                  <Option value="10">Motorizzazione</Option>
                  <Option value="13">Questura</Option>
                  <Option value="14">Polizia</Option>
                  <Option value="16">Commissariato</Option>
                  <Option value="19">Altro</Option>
                </Select>
              ) : key === "password" || key === "confirm_password" ? (
                <Input.Password disabled={role === "agent"} />
              ) : (
                <Input disabled={role === "agent"} />
              ),
            )}
          </Form.Item>
        )
      })

    if (userDetail)
      return (
        <div className="edit-user-form add-service-form" style={{ width: "100%" }}>
          <div className="title">
            {" "}
            <div
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Icon type="user" />
              <h5 onClick={() => history.push(`/back-office/utenti`)}>
                {`Utenti / ${userDetail.username}`}
              </h5>
            </div>
          </div>

          <Form onSubmit={this.handleFormSubmit}>
            {userDetail && Object.keys(userDetail).length > 0 && (
              <span className="form-header">
                {activeSkinId === -1
                  ? "Dati Cliente"
                  : ` Modifica dati ${
                      userDetail.role === "agency" ? "Agenzia" : userDetail.role
                    }`}
              </span>
            )}

            <Row gutter={16}>
              <Col xs={24} sm={12} md={8}>
                {renderFormItems(formMapping.col1)}
              </Col>
              <Col xs={24} sm={12} md={8}>
                {renderFormItems(formMapping.col2)}
              </Col>
              <Col xs={24} sm={12} md={8}>
                {renderFormItems(formMapping.col3)}
              </Col>

              {userDetail.role === "agency" && agents && role !== "agent" && (
                <Col
                  xs={12}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  style={{ paddingBottom: 8, paddingLeft: 8 }}
                >
                  <div className="form-item">
                    <label className="form-label">Cambia Agente</label>
                    <div className="agent-selection-container">
                      <Select
                        defaultValue={userDetail?.account?.agent_id}
                        value={
                          this.state.agentSelected || userDetail?.account?.agent_id
                        }
                        className="agent-select"
                        onChange={(selectedAgentId) => {
                          const selectedAgent = (this.props.agents || []).find(
                            (a) => a.id === selectedAgentId,
                          )

                          const modal = Modal.confirm({
                            title:
                              "Sei sicuro di voler cambiare l'agente dell'utente?",
                            content: `L'utente: ${userDetail.username}\nNuovo agente: ${selectedAgent.first_name} ${selectedAgent.last_name} [${selectedAgent.username}]`,
                            okText: "Sì",
                            cancelText: "No",
                            onOk: async () => {
                              this.setState({ agentSelected: selectedAgentId })

                              const skinId = this.props.activeSkinId
                              await this.props.changeAgent(
                                selectedAgentId,
                                userDetail.id,
                                skinId,
                              )

                              modal.destroy()
                            },
                            onCancel: () => {
                              this.setState({
                                agentSelected: userDetail?.account?.agent_id,
                              })
                            },
                          })
                        }}
                      >
                        {(this.props.agents || []).map((agent, id) => (
                          <Option key={id} value={agent.id}>
                            {agent.first_name} {agent.last_name} [{agent.username}]
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                </Col>
              )}

              {/* Conditional Rendering for Skin Selection (for agent role) */}
              {userDetail.role === "agent" && skinList && (
                <Col
                  xs={12}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  style={{ paddingBottom: 8, paddingLeft: 8 }}
                >
                  <div className="form-item">
                    <label className="form-label">Cambia Skin</label>
                    <div className="agent-selection-container">
                      <Select
                        defaultValue={userDetail.skin_id}
                        onChange={(e) => this.setState({ skinSelected: e })}
                        className="agent-select"
                      >
                        {(this.props.skinList || []).map((skin, id) => (
                          <Option key={id} value={skin.id}>
                            {`${skin.username}`}
                          </Option>
                        ))}
                      </Select>
                      <button
                        type="button"
                        className="confirm-button"
                        onClick={async () => {
                          this.props.changeAgentSkin(
                            userDetail.id,
                            this.state.skinSelected,
                          )
                        }}
                      >
                        <i className="fal fa-check" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </Col>
              )}

              {role !== "agent" && (
                <Col
                  xs={12}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  style={{
                    paddingRight: 0,
                    paddingBottom: 30,
                    marginTop: 22,
                  }}
                >
                  <Row
                    gutter={16}
                    justify="start"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    <Col style={{ flex: 1, paddingBottom: 8 }}>
                      <Button
                        onClick={() => {
                          history.push(`/back-office/utenti`)
                          setUserDetail(null)
                        }}
                        type="default"
                        style={{ width: "100%" }}
                      >
                        Annulla
                      </Button>
                    </Col>
                    <Col style={{ flex: 1, paddingBottom: 8 }}>
                      {userDetail && Object.keys(userDetail).length > 0 && (
                        <Button
                          loading={loading}
                          type="primary"
                          htmlType="submit"
                          style={{
                            width: "100%",
                            backgroundColor: "var(--accent-bg)",
                            borderColor: "var(--accent-bg)",
                          }}
                        >
                          Salva
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          </Form>
        </div>
      )
    else return <div className="loaderAdmin">Loading...</div>
  }
}

const mapStateToProps = (state) => ({
  userDetail: state.auth.userDetail,
  accountInfo: state.auth.accountInfo,
  agents: state.auth.agents,
  skinList: state.auth.skinList,
})

const WrappedEditUser = Form.create()(EditUser)

export default connect(mapStateToProps, { ...AuthActions, ...MainActions })(
  withRouter(WrappedEditUser),
)
